import { Chip, Typography } from '@mui/material';
import { FONT_SIZES } from './constants';

export interface StatusChipProps {
  label: string;
  color: string;
  fontWeight: string;
  variant?: 'filled' | 'outlined';
  size?: 'small' | 'medium';
  showAsText?: boolean;
  backgroundColor?: string;
  borderColor?: string;
}

const StatusChip: React.FC<StatusChipProps> = ({
  label,
  color,
  fontWeight,
  variant = 'filled',
  size = 'small',
  showAsText = false,
  backgroundColor,
  borderColor,
}) => {
  if (showAsText || label === '-') {
    return (
      <Typography variant='body2' color={color} fontWeight={fontWeight}>
        {label}
      </Typography>
    );
  }

  return (
    <Chip
      label={label}
      size={size}
      variant={variant}
      className='status-chip'
      sx={{
        backgroundColor: variant === 'filled' ? color : backgroundColor || 'transparent',
        color: variant === 'filled' ? 'white' : color,
        borderColor: variant === 'outlined' ? borderColor || color : 'transparent',
        fontWeight,
        fontSize: FONT_SIZES.CAPTION,
        textTransform: 'capitalize',
      }}
    />
  );
};

export default StatusChip;